import React, { useRef, useState, useCallback } from 'react';

export default function BeforeAfter({
  beforeSrc,
  afterSrc,
  beforeLabel = 'Pre',
  afterLabel = 'Posle',
  testId = 'before-after-slider',
}) {
  const wrapRef = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const el = wrapRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    setPos((x / rect.width) * 100);
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    update(e.touches ? e.touches[0].clientX : e.clientX);
  };
  const onMove = (e) => {
    if (!dragging.current) return;
    update(e.touches ? e.touches[0].clientX : e.clientX);
  };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={wrapRef}
      className="before-after"
      data-testid={testId}
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={onUp}
    >
      <img src={beforeSrc} alt="Before" draggable={false} />
      <div className="after-wrap" style={{ clipPath: `inset(0 0 0 ${pos}%)` }}>
        <img src={afterSrc} alt="After" draggable={false} />
      </div>
      <span className="label before">{beforeLabel}</span>
      <span className="label after">{afterLabel}</span>
      <div className="handle" style={{ left: `${pos}%`, transform: 'translateX(-50%)' }} />
    </div>
  );
}
